import { useState } from 'react';
import '../../Assets/Styles/CustomerSearch.scss';

const SelectCustomer = ({ data = [], onSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredOptions, setFilteredOptions] = useState([]);

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    if (term.trim() === '') {
      setFilteredOptions([]);
      if (onSelect) onSelect(null); 
      return;
    }

    const lowerCaseTerm = term.toLowerCase();

    const filtered = data.filter(item =>
      (item.customer_name && item.customer_name.toLowerCase().includes(lowerCaseTerm)) ||
      (item.contact_no && item.contact_no.includes(term)) 
    );

    setFilteredOptions(filtered);
  };

  const handleSelect = (item) => {
    setSearchTerm(`${item.customer_name} (${item.contact_no})`);
    setFilteredOptions([]);
    if (onSelect) onSelect(item);
  };

  return (
    <div className="inquiry-search-container">
      <input
        type="text"
        value={searchTerm}
        onChange={handleSearchChange}
        placeholder="Search by name or contact"
        className="inquiry-search-input"
      />
      {filteredOptions.length > 0 && (
        <ul className="inquiry-search-dropdown">
          {filteredOptions.map(item => (
            <li
              key={item.id}
              onClick={() => handleSelect(item)}
              className="inquiry-search-option"
            >
              {item.customer_name} ({item.contact_no})
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SelectCustomer;